
    // this file was auto generated by python script
    // this icon was sourced from feather icons 4.2.8
    import React from 'react';
    const HelpCircle = () => (
      <>
        <circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line>
      </>
    );
    export default HelpCircle;
    